import { RankTrackerConfig } from '../../Model/RankTrackerConfig';
import { AccountRepository } from '../Repositories/AccountRepository';

export class GetRankTrackerConfigUseCase {
  constructor(private readonly repo: AccountRepository) {}

  execute(): Promise<RankTrackerConfig> {
    return this.repo.getRankTrackerConfig();
  }
}
